if (!customElements.get('tr-contact-form')) {
  class TrContactForm extends HTMLElement {
    selectors = {
      postedSuccessfully: '[data-tr-js-posted-successfully]'
    };

    attributes = {
      thankYouUrl: 'data-tr-js-thank-you-url'
    };

    connectedCallback() {
      this.redirectIfPostedSuccessfully();
    }

    redirectIfPostedSuccessfully() {
      if (window.Shopify?.designMode) return;

      const thankYouUrl = this.getAttribute(this.attributes.thankYouUrl);
      const postedSuccessfully = Boolean(this.querySelector(this.selectors.postedSuccessfully));

      if (postedSuccessfully && thankYouUrl) {
        window.location.replace(thankYouUrl);
      }
    }
  }

  customElements.define('tr-contact-form', TrContactForm);
}
